'use client';

import { useEffect } from 'react';

import * as mixpanelUtils from '@/utils/mixpanel';

/**
 * A custom hook to easily access Mixpanel tracking methods.
 * Initializes tracking methods and provides them in a simple object.
 */
export const useMixpanel = () => {
  return mixpanelUtils;
};

/**
 * A hook that auto-tracks page views or specific interactions
 * when the component mounts if needed.
 */
export const useMixpanelEffect = (eventName: string, props?: Record<string, any>) => {
  useEffect(() => {
    mixpanelUtils.trackEvent(eventName, props);
  }, []);
};
